import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";
const deleteratecard = (state) => {
  return axios.delete(API + "inventory/rate-delete/"+state+"/",{headers: authHeader(),});
};
const DeleteRatecardService = {
    deleteratecard,
  };
  export default DeleteRatecardService;